import {Component, OnInit, ViewChild} from '@angular/core';
import {NgForm} from '@angular/forms';
import {Router, ActivatedRoute} from '@angular/router';
import {JhiEventManager} from 'ng-jhipster';
import {StateStorageService} from '../../block/auth/state-storage.service';
import {Principal} from '../../block/auth/principal.service';
import {AuthServerProvider} from '../../block/auth/auth-jwt.service';
import {WelcomeService} from '../welcome/welcome.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})

export class LoginComponent implements OnInit {

  @ViewChild('f') loginForm: NgForm;

  request: any = {};
  // modalRef: BsModalRef;
  showPassword = false;
  account: any;

  isChecked = false;
  isCheckedSalute = false;
  isCheckedAltro = false;

  event: any;

  constructor(
    private eventManager: JhiEventManager,
    private router: Router,
    private stateStorageService: StateStorageService,
    private principal: Principal,
    private route: ActivatedRoute,
    private welcomeService: WelcomeService,
    // private modalService: BsModalService,
    private authServerProvider: AuthServerProvider
  ) {
  }

  ngOnInit(): void {
    this.welcomeService.getEventDetail().subscribe((resEvent: any) => {
      this.event = resEvent;
    });
  }

  // On submit button click
  onSubmit() {

    let errorMsg = '';

    if(!this.request.username && !this.request.password){
      errorMsg += '<li>Email o password mancanti</li>';
    }

    if(this.isChecked === false){
      errorMsg += '<li>Devi accettare il consenso per proseguire</li>';
    }

    if (errorMsg === '') {
      this.authServerProvider.login(this.request).subscribe((response) => {

        this.principal.identity(false);

        this.loginSuccess();

      });
    } else {
      Swal.fire({
        title: '<ul>' + errorMsg + '</ul>',
        confirmButtonText: 'OK',
        icon: 'warning',
        confirmButtonColor:'#F6030A',
      })
    }

  }

  // private openPrivacy() {
  //   this.modalRef = this.modalService.show(
  //     PrivacyModalComponent,
  //     {
  //       class: 'modal-lg',
  //       ignoreBackdropClick: true,
  //       initialState: {
  //         readOnly: true
  //       }
  //     }
  //   );
  // }

  private getAccount() {
    this.principal.identity().then((account) => {
      this.account = account;
      this.welcomeService.getSubscriber(this.account.id).subscribe((subscriber: any) => {
        if(subscriber.needReset === true) {
          this.router.navigate(['/new-password']);
        } else {
          if (subscriber.registred){
            this.router.navigate(['/home']);
          }else{
            this.router.navigate(['/welcome']);
          }
          /*if (subscriber.completed) {

            if (subscriber.registred){
              this.router.navigate(['/complete-registration']);
            }else{
              this.router.navigate(['/welcome']);
             }

          }*/
        }
      });
    });
  }

  private loginSuccess() {
    const redirect = this.stateStorageService.getUrl();

    /*if (redirect) {
      this.stateStorageService.storeUrl(null);
      this.router.navigate([redirect]);
    } else {
      this.stateStorageService.storeUrl(null);
      this.getAccount();
    }*/

    this.stateStorageService.storeUrl(null);
    this.getAccount();

    this.eventManager.broadcast({
      name: 'authenticationSuccess',
      content: 'Sending Authentication Success'
    });
  }
}
